import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Home from '../containers/Home';
import RegisterCali from '../containers/RegisterCali';
import RegisterCaldas from '../containers/RegisterCaldas';
import SimpleSectionCali from '../containers/SimpleSectionCali';
import SimpleSectionCaldas from '../containers/SimpleSectionCaldas';
import SimpleSectionVolcan from '../containers/SimpleSectionVolcan';
import SimpleSectionManizales from '../containers/SimpleSectionManizales';
import Contacto from '../containers/Contacto';
import CompleteRegister from '../containers/CompleteRegister';
import CheckRegisterInfo from '../containers/CheckRegisterInfo';
import Gallery from '../containers/Gallery';
import GalleryCaldas from '../containers/GalleryCaldas';
import Results from '../containers/Results';
import ResultsCaldas from '../containers/ResultsCaldas';
import GalleryManizales from '../containers/GalleryManizales';
import ResultsManizales from '../containers/ResultsManizales';

const App = () => (
  <BrowserRouter basename="/series">
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/contactenos" component={Contacto} />
      {/* <Route exact path="/cali/registro" component={RegisterCali} />
      <Route exact path="/cali/registro/completar-registro" component={CompleteRegister} />
      <Route exact path="/cali/registro/validar-informacion" component={CheckRegisterInfo} /> */}
      <Route exact path="/caldas/registro-hidden" component={RegisterCaldas} />
      <Route exact path="/caldas/registro/completar-registro" component={CompleteRegister} />
      <Route exact path="/caldas/registro/validar-informacion" component={CheckRegisterInfo} />
      <Route exact path="/caldas/galeria" component={GalleryCaldas} />
      <Route exact path="/caldas/resultados" component={ResultsCaldas} />
      <Route exact path="/cali/galeria" component={Gallery} />
      <Route exact path="/cali/resultados" component={Results} />
      <Route exact path="/cali/:slug" component={SimpleSectionCali} />
      <Route exact path="/caldas/:slug" component={SimpleSectionCaldas} />
      <Route exact path="/volcan/:slug" component={SimpleSectionVolcan} />
      <Route exact path="/manizales/galeria" component={GalleryManizales} />
      <Route exact path="/manizales/resultados" component={ResultsManizales} />
      <Route exact path="/manizales/:slug" component={SimpleSectionManizales} />
    </Switch>
  </BrowserRouter>
);

export default App;
